export function hasLogicGame(gameInfo: any) {
  const SPECIAL_GAME_ID = 'uef4312b08dde07820374dd57086ea2fb';
  return gameInfo?.edition_unified_id === SPECIAL_GAME_ID;
}
